import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class JobFullDetailsToolsButtonsMoveJobToDelivered extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      hasSplitParent: this.props.hasSplitParent || false,
      isSplitJob: this.props.isSplitJob || false,
      hasSplitJobs: this.props.hasSplitJobs || false,
      isSplitJobPartA: this.props.isSplitJobPartA || false,
      isSplitJobPartB: this.props.isSplitJobPartB || false,
      apiUrlForMoveJobToDelivered: "/api/v1/portal/jobs/move-to-delivered/",
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }

  moveJobToDelivered() {
    return fetch(
      this.state.apiUrlForMoveJobToDelivered+
      this.state.data.id,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        },
      }
    ).then((responseText) => {
      }
    );
  }

  render() {
    return(
      <span> {(this.state.data.status !== 'completed') ?
        <button
          className="btn btn-lg btn-move-job-to-delivered"
          onClick={() => {
            this.moveJobToDelivered(this.state.data.id)
          }}>
          <i className="fa fa-chevron-circle-right"></i>&nbsp;
          Move Job to Delivered
        </button>
        :
        ''
      }
    </span>
    )
  }
}